module.exports = __webpack_public_path__ + "img/23.359f9a36.jpg";